import { render, staticRenderFns } from "./filtersetting.vue?vue&type=template&id=61d5de24&scoped=true"
import script from "./filtersetting.vue?vue&type=script&lang=js"
export * from "./filtersetting.vue?vue&type=script&lang=js"
import style0 from "./filtersetting.vue?vue&type=style&index=0&id=61d5de24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d5de24",
  null
  
)

export default component.exports